import { apiFetch } from './http';

export interface FulfillmentRequest {
  requestId: string;
  marketplaceCustomerId: string;
  productCode: string;
  status: string;
  tenantId?: string;
  customerEmail?: string;
  companyName?: string;
  receivedAt: string;
  resolvedAt?: string;
  provisionedAt?: string;
  errorMessage?: string;
}

export interface FulfillmentResponse {
  requests: FulfillmentRequest[];
}

export interface ProvisionResult {
  requestId: string;
  tenantId: string;
  onboardingUrl: string;
  status: string;
}


export async function fetchFulfillmentQueue(): Promise<FulfillmentResponse> {
  return apiFetch<FulfillmentResponse>('/ops/fulfillment');
}

export async function triggerFulfillment(input: {
  marketplaceCustomerId: string;
  productCode: string;
  customerEmail: string;
  companyName: string;
  awsAccountId?: string;
}): Promise<ProvisionResult> {
  return apiFetch<ProvisionResult>('/ops/fulfillment', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}
